import {
  ApiDateFormat,
  BaseModel,
} from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  EInvoiceEnvironment,
  EInvoiceState,
  ICustomerData,
  IISPData,
  IInvoice,
  IInvoiceAddress,
  IInvoiceItem,
  IInvoiceTotalVat,
  ILiquidation,
  InvoiceDeliveryType,
  InvoiceOrigin,
  InvoiceSendStatus,
  InvoiceType,
  PaymentLiquidationState,
  PaymentMethod,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';
import { InvoiceCustomer } from './invoice-customer.model';

export class Invoice extends BaseModel<Invoice, 'Invoice'> implements IInvoice {
  static override readonly modelName: AbilitySubjectType = 'Invoice';

  customerId!: string;
  customer?: InvoiceCustomer;
  dueDays!: number;
  internalId!: string;
  externalId!: string | null;
  closureNo!: string | null;
  generated!: boolean;
  corellationId?: string;

  @Type(() => Date)
  date!: Date;

  @Type(() => Date)
  @ApiDateFormat('yyyy-MM-dd')
  dueDate!: Date;

  @Type(() => Date)
  @ApiDateFormat('yyyy-MM-dd')
  period!: Date;

  @Type(() => Date)
  @ApiDateFormat('yyyy-MM-dd')
  from!: Date;

  @Type(() => Date)
  @ApiDateFormat('yyyy-MM-dd')
  to!: Date;

  @Type(() => Date)
  @ApiDateFormat('yyyy-MM-dd')
  deliveryDate!: Date;

  ispData!: IISPData;
  custData!: ICustomerData;
  address!: IInvoiceAddress;
  deliveryType!: InvoiceDeliveryType;
  paymentType!: PaymentMethod;
  items!: IInvoiceItem[];
  sipoNumber?: string;

  total!: number;
  totalBase!: number;
  totalVat!: number;
  totalVatItems!: IInvoiceTotalVat[];

  liquidatedAmount!: number;
  liquidationState!: PaymentLiquidationState;
  liquidations?: ILiquidation[];

  sendStatus!: InvoiceSendStatus;
  sendError?: string;
  eInvoiceState?: EInvoiceState | null;
  eInvoiceEnvironment?: EInvoiceEnvironment | null;

  type!: InvoiceType;
  templateId?: string;
  linkedInvoiceId?: string;
  linkedInvoice?: IInvoice;
  documentId?: string;

  originatedBy?: InvoiceOrigin | undefined;
  @Type(() => Date)
  itemsLastGeneratedAt!: Date | null;
}
